<template>
<div v-if="!loading">
    <table>
        <tbody>
            <tr v-for="(s, i) in sponsorships.slice(0, numTop)" :key="i"
                :class="{ hilight: s.userId === store.currentUser.userId }">
                <td>{{ i + 1 }}</td>
                <td>{{ s.name }}</td>
                <td>{{ $n(s.paid, "currency") }}</td>
            </tr>
            
            <tr v-if="userPosition >= numTop">
                <td>...</td>
                <td></td>
                <td></td>
            </tr>
            <tr v-if="userPosition >= numTop">
                <td>{{ userPosition + 1 }}</td>
                <td>{{ store.currentUser.fullName }}</td>
                <td>{{ $n(sponsorships[userPosition].amount, "currency") }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script lang="ts">
import { store, Event, Sponsorship } from "store";
import axios from "axios";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    data() {
        const loading: boolean = true;
        const userPosition: number = undefined;
        const sponsorships: Sponsorship[] = undefined;

        return {
            sponsorships,
            userPosition,
            loading,
            store: store
        };
    },
    async created() {
        this.sponsorships = (await axios.get(`sponsors/event-sponsorships/${this.event.eventId}`)).data;
            
        this.userPosition = this.sponsorships.findIndex(s => s.userId === store.currentUser.userId);

        this.loading = false;
    },
    props: {
        numTop: {
            default: 10,
            type: Number
        },
        event: {
            type: Object as PropType<Event>
        }
    }
})
</script>